import { NgModule, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
	DocumentSearch,
	IDocumentListPaging
} from '../models/documentModels';
import { CacheService } from './cache.service';
import { KeyValuePair } from '../classes/key-value-pair';
import { map } from 'rxjs/operators';
@NgModule({})
@Injectable({providedIn: 'root'})
export class DocumentService {
	controller_path = 'api/documents/';
	constructor(private http: HttpClient, private cacheService: CacheService) {}

	public getAllDocuments() {
		return this.http.get(this.controller_path + 'GetDocument');
	}

	public getDocumentTypes():any {
		return this.http.get(this.controller_path + 'GetDocumentTypes?entityTypeID=5');
	}

	public download(docId: number, fileName: string) {
		const url = this.controller_path + 'GetDownload/?DocumentID=' + docId+"&FileName="+encodeURIComponent(fileName);
		return this.http.get(url, {'responseType': 'blob'}).pipe(map(
			(res) => {
				// return new Blob([res.blob()], { type: 'application/pdf'});
				return new Blob([res], { type: 'application/pdf'});
			}));
	}

	public searchByKeyWord(search: any): Observable<any> {
		const body = this.cacheService.stringify(search);
		const url = this.controller_path + 'GetDocumentsByKeyWord';
		const cacheId = url + body;

		return this.cacheService.get(
			cacheId,
			this.http.post<IDocumentListPaging>(
				url,
				search,
				{
					headers: new HttpHeaders().set(
						'Content-Type',
						'application/json'
					)
				}
			)
		);
	}

	// Get the current selected document for download, makes a form that opens a new tab...
	public GetDownload(DocumentID: number, fileName: string) {
		const url = this.GetDownloadEndpoint();
		const toSubmit = new Array<KeyValuePair<string, string>>();
		toSubmit.push(new KeyValuePair<string, string>('DocumentID', DocumentID.toString()));
		toSubmit.push(new KeyValuePair<string, string>('FileName', fileName));

		const form = this.BuildHiddenFormForDownload(url, toSubmit);
		const div = document.getElementById('downloadCurrentDocForm');
		div.appendChild(form);
		form.submit();
	}

	public GetDownloadEndpoint() {
		// 'http://localhost:4200/' +
		return this.controller_path + 'GetDownload/';
	}

	public GetPreviewEndpoint() {
		return this.controller_path + 'GetPreview/';
	}

	setFavorite(DocumentID: number, Favorite: boolean) {
		const postData = {DocumentID: DocumentID, Favorite: Favorite};
		return this.http.post(this.controller_path + 'SetDocumentFavorite', postData);
	}

	public BuildHiddenFormForDownload(targetURL: string, elems: Array<KeyValuePair<string, string>>): HTMLFormElement {
		const form = document.createElement('form');
		form.method = 'get';
		form.target = '_blank';
		form.action = targetURL;

		elems.forEach(e => {
			const input = document.createElement('input');
			input.setAttribute('type', 'hidden');
			input.setAttribute('name', e.key);
			input.setAttribute('value', encodeURI(e.value));
			form.appendChild(input);
		});
		return form;
	}

}
